<template>
  <div>
    <div class="page-title">我的申請 My Application</div>
    <el-card class="box-card">
      <div class="home-title">我的申請 My Application</div>
      <el-table :data="applications" style="width: 100%;">
        <el-table-column prop="registrationNo" label="App. ID 申請編號">
        </el-table-column>
        <el-table-column label="Student Name 學生姓名">
          <template slot-scope="{ row }">
            <span v-if="row.applicantName"
              >{{ JSON.parse(row.applicantName).en || "" }}
              {{ JSON.parse(row.applicantName).zh_tc || "" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="App. Form 申請表">
          <template slot-scope="{ row }">
            <span>{{ row.eventStatus.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="App. Status 申請狀況">
          <template slot-scope="{ row }">
            <span>{{ row.status | applicationStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column label="App.Period 申請時間" width="175">
          <template slot-scope="{ row }">
            <span
              >{{ row.eventStatus.startDate | applicationFormatDate }}至{{
                row.eventStatus.endDate | applicationFormatDate
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="lastUpdateAt" label="Last Update 最後更新時間">
          <template slot-scope="{ row }">
            <span>{{ row.lastUpdateAt | applicationFormatDateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Request 提出修改">
          <template slot-scope="{ row }">
            <span v-if="row.status == 0">-</span>
            <span v-else @click="onRequest(row.id)" class="action-link cursor"
              >Request 提出修改</span
            >
          </template>
        </el-table-column>
        <el-table-column width="100" label="View 查看">
          <template slot-scope="{ row }">
            <span
              class="action-link cursor"
              @click="onView(row.id, row.formType)"
              >View 查看</span
            >
          </template>
        </el-table-column>
        <el-table-column label="Action 動作">
          <template slot-scope="{ row }">
            <span v-if=" row.status == 2 || row.status == 4">-</span>&nbsp;
            <span
              v-if="(row.status == 0 || row.status == 3) && handIsBefore(row.eventStatus.endDate) && !row.eventStatus.isExpired"
              @click="onEdit(row.id, row.formType)"
              class="action-link cursor"
              >Edit 繼續填寫</span
            >&nbsp;
            <span
              v-if="row.status == 1 && handIsBefore(row.eventStatus.endDate) && !row.eventStatus.isExpired"
              @click="onPay(row.id)"
              class="action-link cursor"
              >Pay 繳費</span
            >&nbsp;
            <span
              v-if="(row.status == 0 || row.status == 1) && handIsBefore(row.eventStatus.endDate) && !row.eventStatus.isExpired"
              @click="onCancel(row.id)"
              class="action-link cursor"
              >取消申請</span
            >&nbsp;
            <!-- <span
              v-if="(row.status == 1 || row.status == 3) && handIsBefore(row.eventStatus.endDate) && !row.eventStatus.isExpired"
              @click="onUploadReceipt(row.id)"
              class="action-link cursor"
              >upload receipt</span
            > -->
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card class="box-card">
      <div class="home-title">通知 Announcement</div>
      <el-table
        @sort-change="handleSortChange"
        :data="announcements"
        style="width: 100%;"
      >
        <el-table-column prop="createdAt" label="Post Date 發出日期">
          <template slot-scope="{ row }">
            <span>{{ row.createdAt | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="applicationForm.registrationNo"
          label="Reg. No. 申請編號"
        >
        </el-table-column>
        <el-table-column prop="subject" label="Subject 標題">
          <template slot-scope="{ row }">
            <span class="cursor action-link" @click="onSubject(row.id)">{{
              row.subject
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="applicationForm.formType" label="申請類別">
          <template slot-scope="{ row }">
            <span>{{ row.applicationForm.formType | applicationType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isRead" sortable="custom" label="狀態">
          <template slot-scope="{ row }">
            <span>{{ row.isRead | isRead }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery._page"
        :limit.sync="listQuery._limit"
        @pagination="getAnnouncements"
      />
    </el-card>
    <div class="copyright-card">
      <copyrightCard></copyrightCard>
    </div>
    <loadingSlotDialog :centerDialogVisible="centerDialogVisible">
      <img src="@/assets/images/feather-alert-circle.png" />
      <div class="dialog-text">Are you sure to delete this item ?</div>
      <el-button @click="onConfirm" type="danger">Confirm</el-button>
      <el-button @click="centerDialogVisible = false">Cancel</el-button>
    </loadingSlotDialog>
  </div>
</template>

<script>
import loadingSlotDialog from "@/components/loadingSlotDialog";
import { getApplication, deleteApplication } from "@/api/parent/application";
import { getAnnouncements } from "@/api/parent/notification";
import Pagination from "@/components/Pagination";
import copyrightCard from "@/components/copyrightCard";
import moment from 'moment'
export default {
  components: { copyrightCard, Pagination, loadingSlotDialog },
  filters: {
    isRead(v) {
      return v ? "已讀" : "未讀";
    },
  },
  data() {
    return {
      centerDialogVisible: false,
      total: 0,
      announcements: [],
      applications: [],
      listQuery: {
        orderBy:null,
        _page: 1,
        _limit: 10,
      },
    };
  },
  created() {
    this.getAnnouncements();
    this.getApplication();
  },
  methods: {
    handIsBefore(date){
      return !moment(date).isBefore(moment(new Date()).format('YYYY-MM-DD'));
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getAnnouncements();
    },
    onConfirm() {
      this.deleteApplication();
    },
    onCancel(id) {
      this.applicationId = id;
      this.centerDialogVisible = true;
    },
    onUploadReceipt(id) {
      this.$router.push({ path: `/parent/uploadReceipt/${id}` });
    },
    onRequest(id) {
      this.$router.push({ path: `/parent/request/${id}/edit` });
    },
    getApplicationStudentName(row) {
      let newValue = row.filter((v) => {
        return v.type == 0;
      })[0];
      return newValue;
    },
    onSubject(id) {
      this.$router.push({ path: `/parent/announcement/${id}` });
    },
    onView(id, type) {
      this.$router.push({ path: `/parent/application/${id}/${type}/view` });
    },
    onEdit(id, type) {
      this.$router.push({
        path: `/parent/application/${id}/${type}/edit`,
      });
    },
    onPay(applicationId) {
      this.$router.push({ path: `/parent/message/${applicationId}` });
    },
    getAnnouncements() {
      let from = {
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
      };
      getAnnouncements(from).then((v) => {
        this.announcements = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    deleteApplication() {
      deleteApplication(this.applicationId)
        .then(() => {
          this.getApplication();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
    getApplication() {
      getApplication().then((v) => {
        this.applications = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-title {
  color: #337ab7;
  font-weight: bold;
  font-size: 1.5625rem;
  margin-bottom: 1.875rem;
}
.box-card {
  margin-bottom: 1.875rem;
}
.copyright-card {
  background-color: #fff;
}
.dialog-content {
  font-size: 1.875rem;
  margin-bottom: 1.875rem;
}
.dialog-footer {
  display: flex;
}
.dialog-text {
  font-size: 2.25rem;
  color: #272727;
  text-align: center;
}
</style>